import Caption from 'LuxKit/Typography/Caption'
import React from 'react'
import { useIntl } from 'react-intl'
import { middleDotSeparatorMessage } from 'LuxKit/intl/separators'

interface Props {
  location?: string
  primaryCategory?: string
}

function ExperienceLocationCaption({ location, primaryCategory }: Props) {
  const intl = useIntl()
  return (
    <Caption variant="large" lineClamp={1}>
      {location && <Caption as="span" variant="large" colour="neutral-two">{location}</Caption>}
      {location && primaryCategory && <Caption as="span" variant="large" colour="neutral-three">{` ${intl.formatMessage(middleDotSeparatorMessage)} `}</Caption>}
      {primaryCategory && <Caption as="span" variant="large" colour="neutral-three">{primaryCategory}</Caption>}
    </Caption>
  )
}

export default ExperienceLocationCaption
